import Entity from 'utilities/entity';
import Favorite from './favorite';
import TrainingSubscription from './training/subscription';

class User extends Entity {
    
    favorites() {
        return this.hasMany(Favorite);
    }

}

export default new User();